<template>
  <div>
    <EmojiPicker
      v-if="emojiPickerEnabled && emojiPickerVisible"
      @addEmoji="addEmoji"
    />
    <div class="tw-relative">
      <input
        ref="messageComposer"
        v-model="messageText"
        type="text"
        class="tw-outline-none tw-relative tw-rounded-full tw-shadow-chat tw-px-5 tw-py-3 tw-w-full"
        placeholder="Type a message"
        @keydown="inputHandler"
      >
      <div
        v-if="emojiPickerEnabled"
        class="tw-absolute tw-right-0 tw-top-0 tw-bottom-0 tw-flex tw-items-center tw-mr-16 tw-cursor-pointer"
        @click="toggleEmojiPicker"
      >
        <i class="far fa-smile" />
      </div>
      <button
        class="tw-absolute tw-right-0 tw-top-0 tw-text-2xl btn-circle btn-circle-lg tw-bg-gradient-lr tw-text-white"
        @click="sendMessage"
      >
        <i class="fas fa-arrow-alt-circle-right" />
      </button>
    </div>
  </div>
</template>

<script>
import Message from '@/vuex/orm/models/Message';

export default {
  components: {
    EmojiPicker: () => import(/* webpackChunkName: "page--Chat" */ '@/components/chat/EmojiPicker'),
    // GifPicker: () => import(/* webpackChunkName: "page--Chat" */ '@/components/chat/GifPicker'),
  },

  props: {
    chatroom: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    // https://kapeli.com/cheat_sheets/Emoji.docset/Contents/Resources/Documents/index
    return {
      query: '',
      results: false,

      emojiPickerEnabled: true,
      emojiPickerVisible: false,
      gifPickerEnabled: false,
      gifPickerVisible: false,

      show: {
        attachment: false,
        gifPicker: false,
        emojiPicker: false,
      },

      messageText: '',
    };
  },

  methods: {
    toggleGifPicker() {
      if (this.gifPickerVisible) {
        this.$root.$emit('bv::hide::modal', 'gif-picker');
        this.gifPickerVisible = false;
      } else {
        this.$root.$emit('bv::show::modal', 'gif-picker');
        this.gifPickerVisible = true;
      }
    },

    toggleEmojiPicker() {
      this.emojiPickerVisible = !this.emojiPickerVisible;
    },

    inputHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.sendMessage();
      }

      this.tagPeers();
    },

    tagPeers() {
      console.log(`chatroom.${this.chatroom.id}.tagPeers`);
      window.Echo.private(`chatroom.${this.chatroom.id}`).whisper('typing', {
        name: this.$auth.user().profile.nickname,
      });
    },

    sendMessage() {
      // console.log('sendMessage', this.messageText);

      if (this.messageText.length > 0) {
        const messageData = {
          chatroomId: this.chatroom.id,
          message: this.messageText,
        };

        // console.log('sendMessage.chatroom', this.chatroom);
        // console.log('sendMessage.chatroom.messages', this.chatroom.messages);

        Message.api()
          .request({
            method: 'post',
            url: `/api/chat/${this.chatroom.id}/messages`,
            data: messageData,
          })
          .then((/* response */) => {
            // console.log('ChatComposer.sendMessage.response', response);
            Bus.$emit('messages:append', {
              chatroomId: this.chatroom.id,
              user: {
                id: this.$auth.user().id,
                username: this.$auth.user().profile.nickname,
                avatar: this.$auth.user().avatar,
              },
              message: this.messageText,
              timeAgo: '1s',
            });

            this.clearMessage();
          })
          .catch((err) => {
            console.log('ChatComposer.sendMessage.err', err);
            // this.errors = err.response.data.errors;
            // $(window).scrollTop(0);
            // Bus.$emit('modal_scroll_to_top');
            // this.loading = false;
          });

        // console.log(messageData);
        // this.$emit('messageSent', messageData);
        // this.messageText = '';

        Bus.$emit('read:chatroom', this.chatroom.id);
      }
    },

    clearMessage() {
      this.messageText = '';
    },

    addEmoji(e) {
      const textarea = this.$refs.messageComposer;
      const cursorPosition = textarea.selectionStart;
      const emoji = `${e.native}  `;
      this.messageText = [this.messageText.slice(0, cursorPosition), emoji, this.messageText.slice(cursorPosition)].join('');
      this.toggleEmojiPicker();
      this.$refs.messageComposer.focus();
    },
  },
};
</script>
